import { FC } from 'react';
import { PageTitle } from '../../../_metronic/layout/core';
import { View } from './components/View';

const DiscountPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Descuentos</PageTitle>
      <View />
    </>
  );
};

export { DiscountPage };
